import styled from "styled-components";

import { Card } from "components/common";

export const AuthCard = styled(Card)`
  border: 1px solid #f9f9f9;
  box-shadow: 0px 10px 40px #5978960f;
`;
